export default __webpack_public_path__ + "static/media/icon_edit.eb5d9b66.svg";